<template>
  <div class="c-app">
    <TheSidebar :menuNav="menuNav" :initMenu="initMenu"/>
    <CWrapper>
      <TheHeader :initMenu="initMenu"/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import nav from './_nav'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
  data () {
    return { 
      menuNav: []
    }
  },
  methods: {
    initMenu(){
      this.menuNav = nav.map(item => {
          item._children = item._children.map(children =>{
          if(children.key){
            children.name = this.$t(children.key) 
            if(children.items){
              children.items = this.getItemsName(children.items)
            }
          }
          return  children
        })
        return item
      });
    },
    getItemsName (items) {
      return items.map(item =>{
        if(item.key){
          item.name = this.$t(item.key) 
        }
        return item
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
